import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSupabase } from "../lib/supabase";

export default function AdminLogin() {
  const navigate = useNavigate();

  // ✅ Initialize Supabase client
  const supabase = getSupabase();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleLogin(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // ✅ Get Supabase client
      const supabase = await getSupabase();

      // Authenticate
      const { data, error: authError } = await supabase.auth.signInWithPassword(
        {
          email,
          password,
        }
      );

      if (authError) throw authError;

      // Verify admin
      const { data: isAdmin, error: adminError } = await supabase
        .schema("api")
        .rpc("is_admin");

      if (adminError || !isAdmin) {
        await supabase.auth.signOut();
        throw new Error("Unauthorized access");
      }

      navigate("/admin", { replace: true });
    } catch (err) {
      console.error("Admin login error:", err);
      setError("Invalid credentials or unauthorized access.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[rgb(var(--brand-surface))] px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/20 bg-white/70 p-8 shadow-xl backdrop-blur-xl dark:border-white/10 dark:bg-white/5">
        <h1 className="mb-6 text-center text-xl font-semibold text-slate-900 dark:text-white">
          Admin Login
        </h1>

        <form onSubmit={handleLogin} className="space-y-5">
          {/* Email */}
          <div>
            <label className="mb-1 block text-sm text-slate-600 dark:text-slate-400">
              Email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm text-slate-900 outline-none focus:border-[rgb(var(--brand-primary))] focus:ring-1 focus:ring-[rgb(var(--brand-primary))] dark:border-slate-700 dark:bg-slate-900 dark:text-white"
            />
          </div>

          {/* Password */}
          <div>
            <label className="mb-1 block text-sm text-slate-600 dark:text-slate-400">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm text-slate-900 outline-none focus:border-[rgb(var(--brand-primary))] focus:ring-1 focus:ring-[rgb(var(--brand-primary))] dark:border-slate-700 dark:bg-slate-900 dark:text-white"
            />
          </div>

          {/* Error message */}
          {error && (
            <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
          )}

          {/* Submit button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-[rgb(var(--brand-primary))] py-2 text-sm font-medium text-white transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
